<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main">
    <card :title="$t('pageFindHotelInquiry.card.inquiry')" cols="12">
      <hm-card-inner>
        <hm-input v-model="search.name"
                  :lazy="false"
                  :label="$t('pageFindHotelInquiry.search_input')"
                  name="search"
                  cols="12 2@hd 2@desktop 6@tablet"
                  @blur="updateSearch()">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="search" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(search.name)" :border="false" icon="close-text" @click="search.name = null" />
          </template>
        </hm-input>
        <hm-input v-model="filter"
                  :lazy="false"
                  :label="$t('pageFindHotelInquiry.filter')"
                  name="filter"
                  cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="filter" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
          </template>
        </hm-input>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length === 0">
        <h1 class="col-12">{{ $t('pageFindHotelInquiry.search.noResults') }}</h1>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length > 0" :full-size="true">
        <paginated-table :items-per-page="25"
                         :rows="filteredRows"
                         :sticky="true"
                         min-width="600px"
                         columns="9 5@mobile">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('pageFindHotelInquiry.search.inquiryNumber') }}</div>
            <div class="hm-table__th">{{ $t('pageFindHotelInquiry.search.name') }}</div>
            <div class="hm-table__th">{{ $t('pageFindHotelInquiry.search.arrivalDate') }}</div>
            <div class="hm-table__th">{{ $t('pageFindHotelInquiry.search.departureDate') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindHotelInquiry.search.numAdults') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindHotelInquiry.search.numChildren') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindHotelInquiry.search.roomCount') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindHotelInquiry.search.lastEditedAt') }}</div>
            <div class="hm-table__th">{{ $t('pageFindHotelInquiry.search.status') }}</div>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="row in slotProps.currentPage">
              <div class="hm-table__td" @click="openInquiry(row.id)">{{ row.number }}</div>
              <div class="hm-table__td privacy--blur" @click="openInquiry(row.id)">{{ row.guestName || row.companyName }}</div>
              <div v-if="!isEmpty(row.arrivalDate)" class="hm-table__td" @click="openInquiry(row.id)">{{ row.arrivalDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div v-else class="hm-table__td" @click="openInquiry(row.id)"></div>
              <div v-if="!isEmpty(row.departureDate)" class="hm-table__td" @click="openInquiry(row.id)">{{ row.departureDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div v-else class="hm-table__td" @click="openInquiry(row.id)"></div>
              <div class="hm-table__td hidden@mobile" @click="openInquiry(row.id)">{{ row.numAdults }}</div>
              <div class="hm-table__td hidden@mobile" @click="openInquiry(row.id)">{{ row.numChildren }}</div>
              <div class="hm-table__td hidden@mobile" @click="openInquiry(row.id)">{{ row.roomCount }}</div>
              <div class="hm-table__td hidden@mobile" @click="openInquiry(row.id)">{{ row.createdAt | toLocalDateTime }}</div>
              <div class="hm-table__td" @click="openInquiry(row.id)">{{ row.completed ? $t('pageFindHotelInquiry.status.done') : $t('pageFindHotelInquiry.status.new') }}</div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>
    <hm-floating-buttons>
      <hm-floating-button :label="$t('pageFindHotelInquiry.actions.createOffer')" icon="plus" color="blue" @click="addInquiry" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, get, filter, last, find, nth, template, clone, cloneDeep, isEqual, isObject, debounce, lowerCase } from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';

export default {
  name: 'PageFindHotelInquiry',
  components: { HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin],
  props: ['test'],

  data() {
    return {
      search: {
        name: null,
      },
      lastSearch: null,
      filter: null,
      rows: [],
      debouncedUpdateSearch: null,
    };
  },

  computed: {
    filteredRows: function () {
      if (isEmpty(this.filter)) return this.rows;
      return this.rows.filter(it => Object.values(it).filter(str => !isEmpty(str) && lowerCase(str).indexOf(lowerCase(this.filter)) >= 0).length > 0);
    },
  },

  watch: {
    'search.name': function () {
      this.onChangeInput();
    },
  },

  created: function () {
    this.debouncedUpdateSearch = debounce(this.updateSearch, 250);
    this.updateSearch();
  },

  methods: {
    openInquiry: function (inquiryId) {
      this.$router.push({ name: 'inquiry', params: { inquiryId: inquiryId } });
    },
    addInquiry: function () {
      this.$router.push({ name: 'createReservation' });
    },
    onClickSearch: function () {
      this.updateSearch();
    },
    onChangeInput: function () {
      if (!isNil(this.debouncedUpdateSearch)) {
        this.debouncedUpdateSearch();
        this.filter = null;
      }
    },
    updateSearch: function () {
      const currentSearch = cloneDeep(this.search);

      if (isEqual(currentSearch, this.lastSearch)) {
        return;
      }

      this.axios.get(this.serviceUrl('inquiry.find'), {
        params: {
          q: currentSearch.name,
        },
      })
        .then((response) => {
          this.rows = response.data.data;
          this.rows.forEach((it) => {
            it.statusText = this.$t(`HotelInquiryStatus.${it.status}`);
          });

          this.lastSearch = currentSearch;
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageFindHotelInquiry.vue